/** @format */

import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
	selector: '[appNoBackground]'
})
export class NoBackgroundDirective implements AfterViewInit {
	@Input() appNoBackground: string;
	@Input() textColor: string;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	// if appNoBackground is false, there should not be a background on the copy box
	ngAfterViewInit() {
		this.setStyle();
	}
	/* istanbul ignore next */
	// Sets background to transparent
	public setStyle() {
		if (!this.appNoBackground) {
			this.renderer.addClass(this.el.nativeElement, 'transparent-background');
		}
		this.textColor === 'light'
			? this.renderer.addClass(this.el.nativeElement, 'light-text')
			: this.renderer.addClass(this.el.nativeElement, 'dark-text');
	}
}
